// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox_NmA08 {
  width: 18px;
  height: 18px;
}
.checkbox_NmA08 .appearance_JUtCB {
  border: 1px solid var( --color-base300 );
  transition: background-color 0.2s,color 0.2s,transform 0.2s;
  border-radius: var( --size-borderRadiusMedium );
  background-color: var( --color-white );
}
.checkbox_NmA08 .appearance_JUtCB .icon_j4fk1 {
  transition: background-color 0.2s,color 0.2s,transform 0.2s;
}
.checkbox_NmA08[data-value=true] {
  color: var( --color-white );
  font-size: 10px;
}
.checkbox_NmA08[data-value=true] .appearance_JUtCB {
  border: 1px solid var( --color-brand500 );
  background-color: var( --color-brand500 );
}
.checkbox_NmA08 input:focus ~ .appearance_JUtCB {
  border: 2px solid var( --color-brand500 );
}
.checkbox_NmA08[data-value=true] input:focus ~ .appearance_JUtCB {
  background-color: var( --color-brand700 );
  border-top-color: var( --color-brand700 );
  border-left-color: var( --color-brand700 );
  border-right-color: var( --color-brand700 );
  border-bottom-color: var( --color-brand700 );
}
.checkbox_NmA08 input:focus-visible ~ .appearance_JUtCB {
  border-top-width: 2px;
  border-top-color: var( --color-FocusVisBorder );
  border-left-width: 2px;
  border-left-color: var( --color-FocusVisBorder );
  border-right-width: 2px;
  border-right-color: var( --color-FocusVisBorder );
  border-bottom-width: 2px;
  border-bottom-color: var( --color-FocusVisBorder );
}
.checkbox_NmA08:hover input ~ .appearance_JUtCB {
  transition: all var( --time-fast );
  border-top-width: 2px;
  border-top-color: var( --color-brand500 );
  border-left-width: 2px;
  border-left-color: var( --color-brand500 );
  border-right-width: 2px;
  border-right-color: var( --color-brand500 );
  border-bottom-width: 2px;
  border-bottom-color: var( --color-brand500 );
}
.checkbox_NmA08:hover input ~ .appearance_JUtCB .icon_j4fk1 {
  transition: all var( --time-fast );
}
.checkbox_NmA08:hover[data-value=true] input ~ .appearance_JUtCB {
  transition: all var( --time-fast );
  background-color: var( --color-brand700 );
  border-top-color: var( --color-brand700 );
  border-left-color: var( --color-brand700 );
  border-right-color: var( --color-brand700 );
  border-bottom-color: var( --color-brand700 );
}
.checkbox_NmA08:hover[data-value=true] input ~ .appearance_JUtCB .icon_j4fk1 {
  transition: all var( --time-fast );
}
.checkbox_NmA08:active .appearance_JUtCB {
  background-color: var( --color-brand500 );
  border-top-color: var( --color-brand500 );
  border-left-color: var( --color-brand500 );
  border-right-color: var( --color-brand500 );
  border-bottom-color: var( --color-brand500 );
}
.checkbox_NmA08:active[data-value=true] .appearance_JUtCB {
  background-color: var( --color-brand500 );
  border-top-color: var( --color-brand500 );
  border-left-color: var( --color-brand500 );
  border-right-color: var( --color-brand500 );
  border-bottom-color: var( --color-brand500 );
}
.checkbox_NmA08[disabled] .appearance_JUtCB {
  border: 1px solid var( --color-base200 );
  background-color: var( --color-base100 );
}
.checkbox_NmA08[disabled][data-value=true] {
  color: var( --color-base300 );
}
.checkbox_NmA08[disabled][data-value=true] .appearance_JUtCB {
  background-color: var( --color-base100 );
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.checkbox_NmA08.checkbox-dashboard_peVm_ .appearance_JUtCB {
  border-radius: 100px;
}
.checkbox_NmA08.checkbox-dashboard_peVm_[data-value=true] {
  font-size: 9px;
  line-height: 100%;
}
.checkbox_NmA08.checkbox-dashboard_peVm_[data-value=true] .appearance_JUtCB {
  padding-top: 6px;
  padding-bottom: 5px;
}
.checkbox_NmA08.checkbox-none_KfsHP {
  width: 0px;
  height: 0px;
}
.checkbox_NmA08.checkbox-none_KfsHP .appearance_JUtCB {
  background-color: transparent;
  border-top-width: 0px;
  border-top-color: transparent;
  border-left-width: 0px;
  border-left-color: transparent;
  border-right-width: 0px;
  border-right-color: transparent;
  border-bottom-width: 0px;
  border-bottom-color: transparent;
}
.checkbox_NmA08.checkbox-none_KfsHP[data-value=true] {
  color: transparent;
}
.checkbox_NmA08.checkbox-none_KfsHP[data-value=true] .appearance_JUtCB {
  background-color: transparent;
}
.checkbox_NmA08.checkbox-none_KfsHP input:focus ~ .appearance_JUtCB {
  background-color: transparent;
}
.checkbox_NmA08.checkbox-none_KfsHP[data-value=true] input:focus ~ .appearance_JUtCB {
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/theme/Checkbox.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,2DAA2D;EAC3D,+CAA+C;EAC/C,sCAAsC;AACxC;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,sBAAsB;EACtB,gDAAgD;EAChD,uBAAuB;EACvB,iDAAiD;EACjD,wBAAwB;EACxB,kDAAkD;AACpD;AACA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,yCAAyC;EACzC,sBAAsB;EACtB,0CAA0C;EAC1C,uBAAuB;EACvB,2CAA2C;EAC3C,wBAAwB;EACxB,4CAA4C;AAC9C;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,kCAAkC;AACpC;AACA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,6BAA6B;EAC7B,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,+BAA+B;EAC/B,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B","sourcesContent":[".checkbox {\n  width: 18px;\n  height: 18px;\n}\n.checkbox .appearance {\n  border: 1px solid var( --color-base300 );\n  transition: background-color 0.2s,color 0.2s,transform 0.2s;\n  border-radius: var( --size-borderRadiusMedium );\n  background-color: var( --color-white );\n}\n.checkbox .appearance .icon {\n  transition: background-color 0.2s,color 0.2s,transform 0.2s;\n}\n.checkbox[data-value=true] {\n  color: var( --color-white );\n  font-size: 10px;\n}\n.checkbox[data-value=true] .appearance {\n  border: 1px solid var( --color-brand500 );\n  background-color: var( --color-brand500 );\n}\n.checkbox input:focus ~ .appearance {\n  border: 2px solid var( --color-brand500 );\n}\n.checkbox[data-value=true] input:focus ~ .appearance {\n  background-color: var( --color-brand700 );\n  border-top-color: var( --color-brand700 );\n  border-left-color: var( --color-brand700 );\n  border-right-color: var( --color-brand700 );\n  border-bottom-color: var( --color-brand700 );\n}\n.checkbox input:focus-visible ~ .appearance {\n  border-top-width: 2px;\n  border-top-color: var( --color-FocusVisBorder );\n  border-left-width: 2px;\n  border-left-color: var( --color-FocusVisBorder );\n  border-right-width: 2px;\n  border-right-color: var( --color-FocusVisBorder );\n  border-bottom-width: 2px;\n  border-bottom-color: var( --color-FocusVisBorder );\n}\n.checkbox:hover input ~ .appearance {\n  transition: all var( --time-fast );\n  border-top-width: 2px;\n  border-top-color: var( --color-brand500 );\n  border-left-width: 2px;\n  border-left-color: var( --color-brand500 );\n  border-right-width: 2px;\n  border-right-color: var( --color-brand500 );\n  border-bottom-width: 2px;\n  border-bottom-color: var( --color-brand500 );\n}\n.checkbox:hover input ~ .appearance .icon {\n  transition: all var( --time-fast );\n}\n.checkbox:hover[data-value=true] input ~ .appearance {\n  transition: all var( --time-fast );\n  background-color: var( --color-brand700 );\n  border-top-color: var( --color-brand700 );\n  border-left-color: var( --color-brand700 );\n  border-right-color: var( --color-brand700 );\n  border-bottom-color: var( --color-brand700 );\n}\n.checkbox:hover[data-value=true] input ~ .appearance .icon {\n  transition: all var( --time-fast );\n}\n.checkbox:active .appearance {\n  background-color: var( --color-brand500 );\n  border-top-color: var( --color-brand500 );\n  border-left-color: var( --color-brand500 );\n  border-right-color: var( --color-brand500 );\n  border-bottom-color: var( --color-brand500 );\n}\n.checkbox:active[data-value=true] .appearance {\n  background-color: var( --color-brand500 );\n  border-top-color: var( --color-brand500 );\n  border-left-color: var( --color-brand500 );\n  border-right-color: var( --color-brand500 );\n  border-bottom-color: var( --color-brand500 );\n}\n.checkbox[disabled] .appearance {\n  border: 1px solid var( --color-base200 );\n  background-color: var( --color-base100 );\n}\n.checkbox[disabled][data-value=true] {\n  color: var( --color-base300 );\n}\n.checkbox[disabled][data-value=true] .appearance {\n  background-color: var( --color-base100 );\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.checkbox.checkbox-dashboard .appearance {\n  border-radius: 100px;\n}\n.checkbox.checkbox-dashboard[data-value=true] {\n  font-size: 9px;\n  line-height: 100%;\n}\n.checkbox.checkbox-dashboard[data-value=true] .appearance {\n  padding-top: 6px;\n  padding-bottom: 5px;\n}\n.checkbox.checkbox-none {\n  width: 0px;\n  height: 0px;\n}\n.checkbox.checkbox-none .appearance {\n  background-color: transparent;\n  border-top-width: 0px;\n  border-top-color: transparent;\n  border-left-width: 0px;\n  border-left-color: transparent;\n  border-right-width: 0px;\n  border-right-color: transparent;\n  border-bottom-width: 0px;\n  border-bottom-color: transparent;\n}\n.checkbox.checkbox-none[data-value=true] {\n  color: transparent;\n}\n.checkbox.checkbox-none[data-value=true] .appearance {\n  background-color: transparent;\n}\n.checkbox.checkbox-none input:focus ~ .appearance {\n  background-color: transparent;\n}\n.checkbox.checkbox-none[data-value=true] input:focus ~ .appearance {\n  background-color: transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox": `checkbox_NmA08`,
	"appearance": `appearance_JUtCB`,
	"icon": `icon_j4fk1`,
	"checkbox-dashboard": `checkbox-dashboard_peVm_`,
	"checkbox-none": `checkbox-none_KfsHP`
};
export default ___CSS_LOADER_EXPORT___;
